import React from 'react'

import './sideBar.scss'

const SideBarBody = ({ children }) => {
  return <div className="sideBar--body">{children}</div>
}

export default SideBarBody
